export default __webpack_public_path__ + "static/footer-shape-9961c1681bc81f056b03f18abade41d5.png";